import { createClient } from '@supabase/supabase-js'

// Project credentials from Supabase
const SUPABASE_URL = 'https://bjelydvroavsqczejpgd.supabase.co'
const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJqZWx5ZHZyb2F2c3FjemVqcGdkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTEwMjE2MDcsImV4cCI6MjA2NjU5NzYwN30.f-693IO1d0TCBQRiWcSTvjCT8I7bb0t9Op_gvD5LeIE'

if (
  SUPABASE_URL === 'https://<PROJECT-ID>.supabase.co' ||
  SUPABASE_ANON_KEY === '<ANON_KEY>'
) {
  throw new Error('Missing Supabase variables')
}

// Create a Supabase client with custom options for better error handling
const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    // Add a custom fetch function to handle API rate limits better
    fetch: (...args) => {
      return fetch(...args).then((response) => {
        if (response.status === 429) {
          if (import.meta.env.DEV) {
            console.warn('Supabase API rate limit hit, retrying in 1 second')
          }
          return new Promise((resolve) => {
            setTimeout(() => resolve(fetch(...args)), 1000)
          })
        }
        return response
      })
    },
  },
})

// Make supabase client available globally for debugging
if (typeof window !== 'undefined') {
  window.supabase = supabase

  // Log only once and only in DEV (prevents spam)
  if (import.meta.env.DEV && !window.__SUPABASE_CONNECTED_LOGGED__) {
    window.__SUPABASE_CONNECTED_LOGGED__ = true
    console.log('Supabase client ready:', SUPABASE_URL)
  }
}

export default supabase